import React from "react";
import { Row, Col } from "react-bootstrap";
import { BaseCheckboxRadioSwitch, BaseDropdown, BaseForm, BaseInput, CurrencyInput } from "react-epharma-components";
import helpers from "@helpers";

const CrudForm: React.FC = (props: any) => {
  const id = React.createRef<BaseInput>();
  const aggregator = React.createRef<BaseDropdown>();
  const client = React.createRef<BaseDropdown>();
  const benefit = React.createRef<BaseDropdown>();
  const acceptTerm = React.createRef<BaseInput>();
  const limitDays = React.createRef<BaseInput>();
  const limit = React.createRef<any>();
  const minimumValue = React.createRef<any>();
  const rate = React.createRef<any>();
  const recipe = React.createRef<any>();
  const holderOnly = React.createRef<any>();
  const cpfInNote = React.createRef<any>();
  const _this = React.createRef<BaseForm>();

  const inputRefs = [id, aggregator, client, benefit, acceptTerm, limitDays, limit, minimumValue, rate, recipe, holderOnly, cpfInNote];

  return (
    <BaseForm refs={inputRefs} ref={_this} {...props}>
      <Row>
        <BaseInput label="Id" name="id" ref={id} hidden />
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseDropdown
            name="aggregatorId"
            mapping="aggregatorId"
            label="Agregador"
            type="number"
            endpoint={helpers.endpoints.aggregator}
            labelProperty="name"
            valueProperty="id"
            ref={aggregator}
            childField={client}
            childFieldProperty="aggregatorId"
            identifier
          />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseDropdown
            name="clientId"
            mapping="clientId"
            label="Cliente"
            type="number"
            labelProperty="tradeName"
            valueProperty="id"
            endpoint={helpers.endpoints.client}
            ref={client}
            childField={benefit}
            childFieldProperty="clientId"
            identifier
            required
          />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseDropdown name="benefitId" mapping="benefitId" label="Beneficio" type="number" required labelProperty="name" valueProperty="id" endpoint={helpers.endpoints.benefit} ref={benefit} identifier />
        </Col>
      </Row>
      <Row>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <CurrencyInput
            label="Taxa"
            name="rate"
            ref={rate}
            required
            maskOptions={{
              prefix: "",
              suffix: "%",
              allowNegative: false,
              integerLimit: 3,
              allowDecimal: true,
            }}
          />
        </Col>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <CurrencyInput label="Valor Minimo(taxa)" name="minimumValue" ref={minimumValue} required />
        </Col>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <CurrencyInput
            label="Máximo por beneficiário"
            name="limit"
            ref={limit}
            required
            maskOptions={{
              prefix: "",
              suffix: "",
              allowNegative: false,
              allowDecimal: false,
            }}
          />
        </Col>
        <Col xs="3" sm="3" md="3" lg="3" xl="3">
          <CurrencyInput
            label="Prazo máximo para reembolso"
            name="limitDays"
            ref={limitDays}
            required
            maskOptions={{
              prefix: "",
              suffix: "",
              allowNegative: false,
              allowDecimal: false,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseCheckboxRadioSwitch id="chbEpharmaLogo" name="cpfInNote" mapping="cpfInNote" label="CPF obrigatório na Nota" type="switch" ref={cpfInNote} />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseCheckboxRadioSwitch id="recipe" name="recipe" mapping="recipe" label="Exige receita para Medicamentos" type="switch" ref={recipe} />
        </Col>
        <Col xs="4" sm="4" md="4" lg="4" xl="4">
          <BaseCheckboxRadioSwitch id="holderOnly" name="holderOnly" mapping="holderOnly" label="Apenas titular" type="switch" ref={holderOnly} />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="12" md="12" lg="12" xl="12">
          <BaseInput label="Termo de aceite" name="acceptTerm" ref={acceptTerm} required maxLength={800} as="textarea" />
        </Col>
      </Row>
    </BaseForm>
  );
};

export default CrudForm;
